// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"56866b28c73044e8","258":"e9ee598a3bda0538","916":"216bdd69349df23b"}[chunkId] + ".js";
};